import React, { useState } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";

const VideoViewer = ({ url, onClose }) => {
  return (
    <div className="fixed w-screen h-screen z-50 inset-0 backdrop-filter bg-black bg-opacity-10">
      <div className="absolute md:ml-[20%] md:mt-[5%]  lg:ml-[30%] lg:mt-[5%]  md:m-4 bg-bg3 z-50 flex flex-col justify-center rounded items-center top-[35%] md:inset-0 md:w-[45%] lg:w-[40%] w-[100%] h-[30%] md:h-[60%]  shadow-lg overflow-y-auto overflow-x-auto no-scrollbar">
        <div className="flex flex-col relative justify-center items-center w-[100%] h-full py-5 ">
          <AiFillCloseCircle
                className="text-primary absolute text-xl cursor-pointer  top-2 right-2"
                onClick={onClose}
          />
          <video src={url} controls width="600" height="400" className="p-6"></video>
        </div>
      </div>
    </div>
  );
};
export default VideoViewer;
